export class NavigationChanger {
  constructor() {
    this._scrollDuration = 1000;
    this._currentIndex = 0;
    this._newCurrentIndex = null;
    this._blockShift = 50;
    this._linkElements = document.querySelectorAll('[data-navigation-link]');
    // блоки, на которых должно заканчиватся подсвечивание пунктов меню
    this._endingSections = [];

    this._moveTo = new window.MoveTo({
      duration: this._scrollDuration,
      easing: 'easeOutQuart',
    });

    this._documentScrollHandler = this._documentScrollHandler.bind(this);
  }

  init() {
    if (!this._linkElements.length) {
      return;
    }
    // найти блоки, на которых должно заканчиватся подсвечивание пунктов меню
    const allSections = document.querySelectorAll('main > section');
    Array.from(allSections).map((item, index) => {
      if (item.id && index > 1) {
        this._endingSections.push(allSections[index - 1]);
      }
    });
    this._endingSections.push(document.querySelector('.wrapper > footer'));

    this._initMoveTo();
    this._changeLinksActiveState();
    document.addEventListener('scroll', this._documentScrollHandler);
  }

  _documentScrollHandler() {
    this._changeLinksActiveState();
  }

  _changeLinksActiveState() {
    this._linkElements.forEach((link, index) => {
      const currentBlockElement = document.querySelector(`${link.getAttribute('href')}`);
      const endBlockElement = this._endingSections[index];

      if (!currentBlockElement) {
        // eslint-disable-next-line no-console
        console.error('Блока на который ссылается ссылка не существует! Проверьте соответствие href ссылок с id блоков');
        return;
      }
      if (endBlockElement.getBoundingClientRect().bottom > this._blockShift && currentBlockElement.getBoundingClientRect().top <= this._blockShift) {
        link.classList.add('is-active');
      } else {
        link.classList.remove('is-active');
      }

      if (document.body.getBoundingClientRect().bottom + window.innerHeight > this._blockShift && currentBlockElement.getBoundingClientRect().top < this._blockShift) {
        if (this._linkElements[index - 1]) {
          this._linkElements[index - 1].classList.remove('is-active');
        }
        link.classList.add('is-active');
      }
      // При добавлении разделов нужно убирать этот пункт, чтобы срабатывала активность ссылки на этот раздел
      // if (document.body.getBoundingClientRect().bottom < (window.innerHeight + 1000)) {

      //   link.classList.remove('is-active');
      // }

    });
  }

  _removeLinkAnimation() {
    this._linkElements.forEach((link, index) => {
      if (index !== this._currentIndex && index !== this._newCurrentIndex) {
        link.classList.add('is-inactive');
      }
    });
  }

  _addLinkAnimation() {
    this._linkElements.forEach((link) => link.classList.remove('is-inactive'));
    this._currentIndex = this._newCurrentIndex;
  }

  _initMoveTo() {
    this._linkElements.forEach((link, index) => {
      link.addEventListener('click', (evt) => {
        evt.preventDefault();
        const target = document.querySelector(`${link.getAttribute('href')}`);
        if (!target) {
          // eslint-disable-next-line no-console
          console.error('Блока на который ссылается ссылка не существует! Проверьте соответствие href ссылок с id блоков');
          return;
        }
        this._newCurrentIndex = index;
        this._moveTo.move(target);
        this._removeLinkAnimation();
        setTimeout(() => {
          this._addLinkAnimation();
        }, this._scrollDuration);
      });
    });
  }
}
